import React, { useState, useEffect, useRef } from "react";
import Utils from "../../utility";
import { getReportList } from "../../services/zbrainConnectorService";
import { useLocation, useNavigate } from "react-router-dom";
import Report from "./report";

const ReportListComponent = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const navigate = useNavigate();
  const [report, setReport] = useState({});
  const [date, setDate] = useState({
    startDate: queryParams.get("fromDate") || null,
    endDate: queryParams.get("toDate") || null
  });
  const [selectTime, setSelectTime] = useState(
    queryParams.get("selectTime") || "All"
  );
  const [selectedVersion, setSelectedVersion] = useState(
    queryParams.get("selectedVersion") || "Latest"
  );
  const [processedDate, setProcessedDate] = useState({
    startDate: queryParams.get("processedOnFrom") || null,
    endDate: queryParams.get("processedOnTo") || null
  });

  const [feedbackDate, setFeebackDate] = useState({
    startDate: queryParams.get("feedbackFromDate") || null,
    endDate: queryParams.get("feedbackToDate") || null
  });
  const [loading, setLoading] = useState(false);

  const [selectProcessedTime, setSelectProcessedTime] = useState(
    queryParams.get("processedTime") || "Last 14 days"
  );

  const [selectFeedbackTime, setSelectFeedbackTime] = useState(
    queryParams.get("feedbackTime") || "Last 14 days"
  );
  const controllerRef = useRef(null);

  const getClaims = async () => {
    if (controllerRef.current) {
      controllerRef.current.abort(); // cancel previous request
    }
    controllerRef.current = new AbortController();
    try {
      let requesData = {};
      setLoading(true);
      if (selectedVersion) {
        requesData.versionScope =
          selectedVersion === "Latest"
            ? "latest"
            : selectedVersion === "All"
              ? "all"
              : selectedVersion;
      }
      if (selectTime !== "Custom" && selectTime !== "All") {
        const { startDate, endDate } = Utils.getDateRange(selectTime);
        requesData.fromDate = startDate;
        requesData.toDate = endDate;
      }
      if (date.startDate && date.endDate && selectTime === "Custom") {
        requesData.fromDate = date.startDate;
        requesData.toDate = date.endDate;
      }

      if (selectProcessedTime !== "Custom" && selectProcessedTime !== "All") {
        const { startDate, endDate } =
          Utils.getDateRangeProcessed(selectProcessedTime);
        requesData.processedOnFrom = startDate;
        requesData.processedOnTo = endDate;
      }
      if (
        processedDate.startDate &&
        processedDate.endDate &&
        selectProcessedTime === "Custom"
      ) {
        const startDateObject = new Date(
          processedDate.startDate.split("-").reverse().join("-")
        );
        const startUTCDate = Date.UTC(
          startDateObject.getUTCFullYear(),
          startDateObject.getUTCMonth(),
          startDateObject.getUTCDate(),
          0,
          0,
          0,
          0
        );
        requesData.processedOnFrom = startUTCDate;
        let endDateObject = new Date(
          processedDate.endDate.split("-").reverse().join("-")
        );
        const endUTCDate = Date.UTC(
          endDateObject.getUTCFullYear(),
          endDateObject.getUTCMonth(),
          endDateObject.getUTCDate(),
          23,
          59,
          59,
          999
        );

        requesData.processedOnTo = endUTCDate;
      }
      if (selectFeedbackTime !== "Custom" && selectFeedbackTime !== "All") {
        const { startDate, endDate } =
          Utils.getDateRangeProcessed(selectFeedbackTime);
        requesData.feedbackFromDate = startDate;
        requesData.feedbackToDate = endDate;
      }
      if (
        feedbackDate.startDate &&
        feedbackDate.endDate &&
        selectFeedbackTime === "Custom"
      ) {
        const startDateObject = new Date(
          feedbackDate.startDate.split("-").reverse().join("-")
        );
        const startUTCDate = Date.UTC(
          startDateObject.getUTCFullYear(),
          startDateObject.getUTCMonth(),
          startDateObject.getUTCDate(),
          0,
          0,
          0,
          0
        );
        requesData.feedbackFromDate = startUTCDate;
        let endDateObject = new Date(
          feedbackDate.endDate.split("-").reverse().join("-")
        );
        const endUTCDate = Date.UTC(
          endDateObject.getUTCFullYear(),
          endDateObject.getUTCMonth(),
          endDateObject.getUTCDate(),
          23,
          59,
          59,
          999
        );

        requesData.feedbackToDate = endUTCDate;
      }

      const signal = controllerRef.current.signal;
      const [error, response] = await Utils.parseResponse(
        getReportList(requesData, signal)
      );

      if (error || !response) {
        return;
      }

      setReport(response);
      setLoading(false);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const updateDateParams = () => {
    if (
      date?.endDate !== null &&
      date?.startDate !== null &&
      selectTime === "Custom"
    ) {
      queryParams.set("toDate", date.startDate);
      queryParams.set("fromDate", date.endDate);
    } else {
      queryParams.delete("toDate");
      queryParams.delete("fromDate");
    }
  };

  const updateProcessedParams = () => {
    if (
      processedDate?.endDate !== null &&
      processedDate?.startDate !== null &&
      selectProcessedTime === "Custom"
    ) {
      queryParams.set("processedOnTo", processedDate.startDate);
      queryParams.set("processedOnFrom", processedDate.endDate);
    } else {
      queryParams.delete("processedOnTo");
      queryParams.delete("processedOnFrom");
    }
  };

  const updateFeedbackParams = () => {
    if (
      feedbackDate?.endDate !== null &&
      feedbackDate?.startDate !== null &&
      selectFeedbackTime === "Custom"
    ) {
      queryParams.set("feedbackToDate", feedbackDate.startDate);
      queryParams.set("feedbackFromDate", feedbackDate.endDate);
    } else {
      queryParams.delete("feedbackToDate");
      queryParams.delete("feedbackFromDate");
    }
  };

  useEffect(() => {
    updateDateParams();
    queryParams.set("selectTime", selectTime);
    updateProcessedParams();
    queryParams.set("processedTime", selectProcessedTime);
    updateFeedbackParams();
    queryParams.set("feedbackTime", selectFeedbackTime);
    queryParams.set("selectedVersion", selectedVersion);
    navigate(
      {
        search: queryParams.toString()
      },
      { replace: true }
    );
    getClaims();
  }, [
    selectTime,
    selectProcessedTime,
    date,
    processedDate,
    selectFeedbackTime,
    feedbackDate,
    selectedVersion
  ]);

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-wrap items-center gap-2">
        <img
          onClick={() => navigate(-1)}
          src="/images/left-arrow.svg"
          alt=""
          className="cursor-pointer"
        />
        <span className="font-InterBold text-ft25-30 text-black-10">
          Regular Report
        </span>
      </div>
      <Report
        date={date}
        processedDate={processedDate}
        report={report}
        selectProcessedTime={selectProcessedTime}
        selectTime={selectTime}
        setDate={setDate}
        setProcessedDate={setProcessedDate}
        setSelectProcessedTime={setSelectProcessedTime}
        setSelectTime={setSelectTime}
        setFeebackDate={setFeebackDate}
        feedbackDate={feedbackDate}
        setSelectFeedbackTime={setSelectFeedbackTime}
        selectFeedbackTime={selectFeedbackTime}
        loading={loading}
        setSelectedVersion={setSelectedVersion}
        selectedVersion={selectedVersion}
      />
    </div>
  );
};

export default ReportListComponent;
